export enum RodzajProjektu {
  srodkiTrwale,
  magazyny,
}
